import { useDeleteSiteLogo, useSiteLogo, useUploadSiteLogo } from "@/hooks/useSiteLogo";
import { Button } from "@simplicity/ui";
import { Upload, X } from "lucide-react";
import { useRef } from "react";

export function LogoSection() {
  const { data: siteLogo } = useSiteLogo();
  const uploadLogo = useUploadSiteLogo();
  const deleteLogo = useDeleteSiteLogo();
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <section>
      <h2 className="text-lg font-semibold mb-4">Landing Page Logo</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Upload a logo that will be displayed on the landing page below the header.
      </p>
      {/* Hidden native file input triggered by the visible "Replace" Button below
          via the fileInputRef. @simplicity/ui has no FileInput primitive; the
          visible affordance is the Button. SIM-1452 tracks broader Button
          variant work, not this. */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) uploadLogo.mutate(file);
          if (fileInputRef.current) fileInputRef.current.value = "";
        }}
        className="hidden"
      />
      {siteLogo ? (
        <div className="flex items-center gap-4">
          <div className="border border-border rounded p-3 bg-muted">
            <img src={siteLogo} alt="Site logo" className="max-h-20 max-w-[240px] object-contain" />
          </div>
          <div className="flex flex-col gap-2">
            <Button onClick={() => fileInputRef.current?.click()} disabled={uploadLogo.isPending}>
              <Upload className="h-4 w-4" /> Replace
            </Button>
            <Button
              variant="outline"
              className="text-destructive border-border hover:bg-destructive/10"
              onClick={() => void deleteLogo.mutate()}
              disabled={deleteLogo.isPending}
            >
              <X className="h-4 w-4" /> Remove
            </Button>
          </div>
        </div>
      ) : (
        <Button onClick={() => fileInputRef.current?.click()} disabled={uploadLogo.isPending}>
          <Upload className="h-4 w-4" />
          {uploadLogo.isPending ? "Uploading..." : "Upload Logo"}
        </Button>
      )}
    </section>
  );
}
